// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartPageTemplateBreakpoint, cartPageTemplateStyles } from "@west/App/Components/Cart/CartPageTemplate";
import { DivWrapper } from "@west/XDL/constants";
import { color, xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

cartPageTemplateStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: minmax(0, 995px) minmax(0, 317px);
        grid-column-gap: 22px;
        ${xScreen("lte", "sm")} {
            grid-template-columns: minmax(0, 360px) minmax(0, 360px);
            grid-column-gap: 20px;
        }
        @media print {
            display: block;
        }
    `,
};
cartPageTemplateStyles.headerSection = {
    css: css`
        grid-row: 1/2;

        ${xScreen("lte", cartPageTemplateBreakpoint)} {
            grid-column: 1/3;
        }
        @media print {
            width: 100%;
        }
    `,
};
cartPageTemplateStyles.titleSection = {
    css: css`
        width: 100%;
        margin-bottom: 12px;
    `,
};
cartPageTemplateStyles.actionsSection = {
    css: css`
        width: 100%;
        padding-bottom: 8px;
        ${xScreen("lte", "md")} {
            border-bottom: 1px solid ${color("common.border")};
        }
        ${xScreen("lte", cartPageTemplateBreakpoint)} {
            margin-top: 32px;
        }
    `,
};
cartPageTemplateStyles.mainSection = {
    css: css`
        grid-row: 2/3;

        ${xScreen("lte", cartPageTemplateBreakpoint)} {
            grid-row: 3/3;
            grid-column: 1/3;

            width: 100%;
            padding: 0;
            margin-top: 0;
            margin-bottom: 0;
        }
        @media print {
            width: 100%;
        }
    `,
};
cartPageTemplateStyles.totalSection = {
    css: css`
        grid-row: 1/4;
        // XNG-Sticky
        & > div.xng-sticky > ${DivWrapper} > div:not(:last-child) {
            margin-bottom: 20px;
        }

        ${xScreen("lte", cartPageTemplateBreakpoint)} {
            grid-row: 2/3;
            grid-column: 1/3;

            width: 100%;
            display: flex;
            justify-content: center;
            & > div.xng-sticky > ${DivWrapper} {
                height: auto;
            }

            & > div.xng-sticky {
                max-width: 300px;
            }
        }

        ${xScreen("lte", "xs")} {
            & > div.xng-sticky {
                max-width: 100%;
            }
        }

        @media print {
            & > div.xng-sticky {
                position: static;
            }
        }

        ${xScreen("lte", "sm")} {
            ${({ isReview }: any) => {
                if (isReview) {
                    return css`
                        display: none;
                    `;
                }
            }}
        }
    `,
};
cartPageTemplateStyles.cartApproverMessage = {
    css: css`
        margin-bottom: 12px;
        &:has(div[class^="Wrapper-sc"]:empty) {
            display: none;
        }
    `,
};
cartPageTemplateStyles.cartFulfullmentSelector = {
    css: css`
        margin-bottom: 24px;
        &:has(div[class^="Wrapper-sc"]:empty) {
            display: none;
        }
    `,
};
cartPageTemplateStyles.xngStickyStyles = {
    css: css`
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};
